module.exports = __webpack_public_path__ + "media/images/suppliers/healthcare-bd69fd10541a937b228500abd2844e47.png";